import type { JobStage, JobStatus } from "../types/job";

export function formatBytes(bytes: number): string {
    if (bytes <= 0) return "0 B";
    const units = ["B", "KB", "MB", "GB"];
    const exponent = Math.min(Math.floor(Math.log(bytes) / Math.log(1024)), units.length - 1);
    const value = bytes / 1024 ** exponent;
    return `${exponent === 0 ? value : value.toFixed(1)} ${units[exponent]}`;
}

export function formatDate(iso: string): string {
    try {
        return new Intl.DateTimeFormat("it-IT", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        }).format(new Date(iso));
    } catch {
        return iso;
    }
}

export const STATUS_LABELS: Record<JobStatus, string> = {
    created: "Creato",
    uploading: "In caricamento",
    uploaded: "Caricato",
    scanning: "Scansione antivirus",
    rejected: "File rifiutato",
    queued: "In coda",
    processing: "Conversione in corso",
    completed: "Completato",
    failed: "Conversione fallita",
    expired: "File scaduto",
    deleted: "Eliminato",
};

export const STAGE_LABELS: Record<JobStage, string> = {
    upload: "Caricamento del file",
    validation: "Verifica del file",
    antivirus: "Scansione antivirus",
    queued: "In coda per la conversione",
    conversion: "Lettura del PDF",
    markdown_export: "Generazione del Markdown",
    cleanup: "Preparazione del download",
    completed: "Completato",
};

type StatusTone = "neutral" | "info" | "success" | "danger" | "warning";

export const STATUS_TONES: Record<JobStatus, StatusTone> = {
    created: "neutral",
    uploading: "info",
    uploaded: "info",
    scanning: "info",
    rejected: "danger",
    queued: "info",
    processing: "info",
    completed: "success",
    failed: "danger",
    expired: "warning",
    deleted: "neutral",
};

export const STATUS_TONE_CLASSES: Record<StatusTone, string> = {
    neutral: "bg-gray-100 text-gray-700 dark:bg-gray-800 dark:text-gray-200",
    info: "bg-blue-100 text-blue-700 dark:bg-blue-900/50 dark:text-blue-200",
    success: "bg-green-100 text-green-700 dark:bg-green-900/50 dark:text-green-200",
    danger: "bg-red-100 text-red-700 dark:bg-red-900/50 dark:text-red-200",
    warning: "bg-amber-100 text-amber-700 dark:bg-amber-900/50 dark:text-amber-200",
};
